(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q4-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('q4-hero-slider').forEach(function(slider) {
  const track = slider.querySelector('[data-q4-hero-track]');
  const slides = Array.from(slider.querySelectorAll('[data-q4-hero-slide]'));
  const dots = Array.from(slider.querySelectorAll('[data-q4-hero-dot]'));
  const previous = slider.querySelector('[data-q4-hero-prev]');
  const next = slider.querySelector('[data-q4-hero-next]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let activeIndex = 0;
  let timer;

  function selectSlide(index) {
    activeIndex = (index + slides.length) % slides.length;
    track.style.transform = 'translate3d(-' + (activeIndex * 100) + '%, 0, 0)';
    slides.forEach(function(slide, slideIndex) {
      slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
    });
    dots.forEach(function(dot, dotIndex) {
      const selected = dotIndex === activeIndex;
      dot.classList.toggle('is-active', selected);
      dot.setAttribute('aria-selected', String(selected));
    });
  }

  function stopAutoplay() {
    window.clearInterval(timer);
  }

  function startAutoplay() {
    stopAutoplay();
  }

  previous.addEventListener('click', function() { selectSlide(activeIndex - 1); startAutoplay(); });
  next.addEventListener('click', function() { selectSlide(activeIndex + 1); startAutoplay(); });
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { selectSlide(Number(dot.dataset.q4HeroDot)); startAutoplay(); });
  });
  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);
  slider.addEventListener('focusin', stopAutoplay);
  slider.addEventListener('focusout', startAutoplay);
  startAutoplay();
});

document.addEventListener('click', async function(event) {
  const carouselControl = event.target.closest('[data-carousel-direction]');
  if (carouselControl) {
    const carousel = document.getElementById(carouselControl.dataset.carouselTarget);
    if (carousel) carousel.scrollBy({ left: carousel.clientWidth * 0.82 * Number(carouselControl.dataset.carouselDirection), behavior: 'smooth' });
    return;
  }
  const button = event.target.closest('[data-bundle-variants], [data-q4-ebook-bundle]');
  if (!button) return;
  const bundleIds = button.dataset.bundleVariants || button.dataset.q4EbookBundle;
  const ids = bundleIds.split(',').filter(Boolean);
  const isEbookBundle = Boolean(button.dataset.q4EbookBundle);
  if (isEbookBundle && button.dataset.cartReady === 'true') {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    window.location.href = root + 'cart';
    return;
  }
  if (ids.length < 2) return;
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = isEbookBundle ? 'Dodaję komplet…' : 'Dodawanie...';
  try {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function(id) { return isEbookBundle ? { id: Number(id), quantity: 1 } : { id: Number(id), quantity: 1, properties: { '_zestaw_rabat_10': 'Tak' } }; }) })
    });
    if (!response.ok) throw new Error('cart add failed');
    if (isEbookBundle) {
      button.dataset.cartReady = 'true';
      button.textContent = 'Dodano komplet ✓ · Zobacz koszyk →';
      button.disabled = false;
      return;
    }
    window.location.href = root + 'cart';
  } catch (error) {
    button.disabled = false;
    button.textContent = 'Spróbuj ponownie';
    window.setTimeout(function() { button.textContent = originalText; }, 2500);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q4-product-sales"] && !Shopify.designMode) return;
  try {
    
  class Q4ProductSales extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true' || !this.dataset.productId) return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', this.handleClick.bind(this));

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        this.loadRecommendations();
      }, { rootMargin: '0px 0px 400px 0px' });

      observer.observe(this);
    }

    async fetchIntent(intent) {
      const url = `${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}&intent=${intent}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    hasCards(element) {
      return Boolean(element?.querySelector('article'));
    }

    async loadRecommendations() {
      const relatedBlock = this.querySelector('[data-q4-related-block]');
      const bundleBlock = this.querySelector('[data-q4-bundle-block]');

      try {
        const relatedDocument = await this.fetchIntent('related');
        const relatedContent = relatedDocument.querySelector('[data-q4-related-target]');
        const relatedFallbackBundle = relatedDocument.querySelector('[data-q4-bundle-target]');

        if (this.hasCards(relatedContent)) {
          this.querySelector('[data-q4-related-target]').replaceChildren(...relatedContent.children);
        } else {
          relatedBlock.hidden = true;
        }

        let bundleDocument = await this.fetchIntent('complementary');
        let bundleContent = bundleDocument.querySelector('[data-q4-bundle-target]');

        if (!this.hasCards(bundleContent)) bundleContent = relatedFallbackBundle;

        if (this.hasCards(bundleContent)) {
          this.querySelector('[data-q4-bundle-target]').replaceChildren(...bundleContent.children);
        } else {
          bundleBlock.hidden = true;
        }
      } catch (error) {
        bundleBlock.hidden = true;
        relatedBlock.hidden = true;
      }
    }

    async handleClick(event) {
      const scrollButton = event.target.closest('[data-q4-scroll]');
      if (scrollButton && this.contains(scrollButton)) {
        const selector = scrollButton.dataset.q4Scroll === 'bundles'
          ? '[data-q4-bundle-target]'
          : '[data-q4-related-target]';
        const track = this.querySelector(selector);
        const direction = Number(scrollButton.dataset.q4Direction || 1);
        track?.scrollBy({ left: direction * track.clientWidth * 0.88, behavior: 'smooth' });
        return;
      }

      const button = event.target.closest('[data-q4-add-bundle]');
      if (!button || !this.contains(button)) return;

      const status = button.parentElement.querySelector('[data-q4-bundle-status]');
      const productFormVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const mainVariant = Number(productFormVariant?.value || button.dataset.mainVariant);
      const addonVariant = Number(button.dataset.addonVariant);
      const originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'Dodaję zestaw…';
      status.textContent = '';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              { id: mainVariant, quantity: 1 },
              { id: addonVariant, quantity: 1 }
            ]
          })
        });

        if (!response.ok) throw new Error('Nie udało się dodać zestawu.');
        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (error) {
        status.textContent = 'Nie udało się dodać zestawu. Spróbuj ponownie.';
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  }

  if (!customElements.get('q4-product-sales')) {
    customElements.define('q4-product-sales', Q4ProductSales);
  }

  } catch(e) { console.error(e); }
})();
})();
